// extracted by mini-css-extract-plugin
export default {"tooltipText":"tooltipText__CDO8l"};
    if(module.hot) {
      // 1792076463222
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  